import { connectVoiceSearch } from 'react-instantsearch-core';
import VoiceSearch from "../components/VoiceSearch.js";
export default connectVoiceSearch(VoiceSearch, {
  $$widgetType: 'ais.voiceSearch'
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-dom/dist/es/widgets/VoiceSearch.js
// module id = 655
// module chunks = 1